import {jsx} from 'panel';

import {BooleanOperator} from 'common/widgets/property-filter-menu/models/types';
import {RadioButtonEl} from 'common/components/radio-button';

import {FilterValueProps} from '../types';

export function FilterBooleanValue({filter, onChange, hasNewUI}: FilterValueProps) {
  return (
    hasNewUI && (
      <div sel='.radio-btns'>
        <RadioButtonEl
          attrs={{selected: filter.filterOperator === BooleanOperator.True}}
          on={{click: () => onChange(true)}}
        >
          True
        </RadioButtonEl>
        <RadioButtonEl
          attrs={{selected: filter.filterOperator === BooleanOperator.False}}
          on={{click: () => onChange(false)}}
        >
          False
        </RadioButtonEl>
      </div>
    )
  );
}
